import { render } from "./OverheadDash.vue?vue&type=template&id=115d2281&scoped=true"
import script from "./OverheadDash.vue?vue&type=script&lang=js"
export * from "./OverheadDash.vue?vue&type=script&lang=js"

import "./OverheadDash.vue?vue&type=style&index=0&id=115d2281&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115d2281"]])

export default __exports__